import { stretchBlock } from '@anm/styles/helpers';
import styled from 'styled-components';
export var LoaderWrapper = styled.div.withConfig({
  componentId: "sc-5ceswc-0"
})(["", " z-index:3;display:flex;align-items:center;justify-content:center;pointer-events:none;"], stretchBlock);
export var PlayerLoader = styled.div.withConfig({
  componentId: "sc-5ceswc-1"
})(["background:", ";border-radius:50%;position:relative;width:92px;height:92px;@keyframes spin{100%{transform:rotate(360deg);}}animation:spin 0.5s infinite linear;margin:0 auto;svg{position:absolute;top:3px;right:3px;}"], function (_ref) {
  var transparent = _ref.transparent;
  return transparent ? 'transparent' : 'rgba(41, 42, 43, 0.8)';
});
export var LoaderMessage = styled.p.withConfig({
  componentId: "sc-5ceswc-2"
})(["font-family:Inter;font-style:normal;font-weight:bold;font-size:12px;line-height:15px;text-align:center;color:#fff;margin-top:8px;"]);
export var ContentWrapper = styled.div.withConfig({
  componentId: "sc-5ceswc-3"
})(["transform:translateY(-10px);"]);